var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsOptional, IsString, IsUUID } from 'class-validator';
import { IsWithinCalendarHorizon } from '../validators/calendar-horizon.js';
import { CreateExerciseProgramItemDto } from './create-exercise-program-item.dto.js';
export class CreateExerciseProgramDto {
    userId;
    /* @ValidateNested({ each: true }) */ // TODO: Does not work in e2e-tests for some reason
    exerciseProgramItems;
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    startDate = new Date();
    endDate;
    officeProductAssignmentId;
    /**
     * Optional free-text "Information für den Patienten" for this new program. When
     * set, it is stored as a program message and surfaced in the
     * NEW_EXERCISE_PROGRAM notification + email.
     */
    patientMessage;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], CreateExerciseProgramDto.prototype, "userId", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => CreateExerciseProgramItemDto),
    __metadata("design:type", Array)
], CreateExerciseProgramDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnMonday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnTuesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnWednesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnThursday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnFriday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnSaturday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CreateExerciseProgramDto.prototype, "trainingIsOnSunday", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Date)
], CreateExerciseProgramDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    IsWithinCalendarHorizon(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CreateExerciseProgramDto.prototype, "endDate", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CreateExerciseProgramDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CreateExerciseProgramDto.prototype, "patientMessage", void 0);
//# sourceMappingURL=create-exercise-program.dto.js.map